import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { CallSheets } from '@/components/fundraising';

// The Call books tab: every book with its progress. Fundraising:Manage — renaming and deleting a book
// are the Fundraiser's.
export const Route = createFileRoute('/admin/fundraising/call-books/')({
  beforeLoad: ({ context }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, '/admin/fundraising/call-books');
  },
  component: CallSheets,
});
